import { render, staticRenderFns } from "./ODashboardMenu.vue?vue&type=template&id=1ea86a38&"
import script from "./ODashboardMenu.vue?vue&type=script&lang=js&"
export * from "./ODashboardMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports